export default function WorkstationsController(
  $q,
  $rootScope,
  $scope,
  confirmDialog,
  alerts,
  loaderService,
  userService,
  bcpDataService,
  editWorkstationDialog,
  deleteWorkstationsDialog,
  ssDialogService,
) {
  const vm = this;

  vm.handleAdd = _handleAdd;
  vm.handleDelete = _handleDelete;
  vm._handleSynchronizeFromEndpointManagement = _handleSynchronizeFromEndpointManagement;
  vm.handleImportedWorkstations = _handleImportedWorkstations;

  _activate();

  /** *********************************************
   * Event Handlers
   */

  function _handleAdd($event) {
    ssDialogService.dialogs.bcp.editWorkstationDialog = ssDialogService.alert(
      editWorkstationDialog.getOptions($event, {
        customerId: vm.customerId,
        assessmentId: vm.assessmentId,
        workstation: {
          assessmentId: vm.assessmentId,
          assessmentWorkstationId: -1,
        },
      }),
    );
    ssDialogService.show(ssDialogService.dialogs.bcp.editWorkstationDialog);
  }

  function _handleDelete($event) {
    ssDialogService.dialogs.bcp.deleteWorkstationsDialog = ssDialogService.alert(
      deleteWorkstationsDialog.getOptions($event, {
        assessmentId: vm.assessmentId,
        workstations: vm.workstations,
      }),
    );

    ssDialogService.show(ssDialogService.dialogs.bcp.deleteWorkstationsDialog);
  }

  function _handleSynchronizeFromEndpointManagement($event) {
    if (vm.hasDatto) {
      _confirmSynchronizeFromDatto($event);
    } else {
      _confirmSynchronizeFromNetComply($event);
    }
  }

  function _confirmSynchronizeFromDatto($event) {
    bcpDataService.getDattoWorkstationCount().then(response => {
      const count = response.data;
      ssDialogService.dialogs.bcp.confirmImportWorkstatonsFromEndpointManagementDialog = ssDialogService.alert(
        confirmDialog.getOptions($event, {
          dialogTitle: 'Synchronize Workstations with Endpoint Management?',
          warningMessage: `Synchronizing "Workstations" with Endpoint Management will delete the existing inventory in your BCMP.`,
          message: `Do you want to continue with syncing your ${count} workstations?`,
          handleYesClick: _performSynchronizeFromDatto,
          handleNoClick: _closeConfirmImportFromEndpointManagementDialog,
        }),
      );

      ssDialogService.show(ssDialogService.dialogs.bcp.confirmImportWorkstatonsFromEndpointManagementDialog);
    });
  }

  function _confirmSynchronizeFromNetComply($event) {
    bcpDataService.getNetComplyWorkstationCount().then(response => {
      const count = response.data;
      ssDialogService.dialogs.bcp.confirmImportWorkstatonsFromEndpointManagementDialog = ssDialogService.alert(
        confirmDialog.getOptions($event, {
          dialogTitle: 'Synchronize Workstations with Endpoint Management?',
          warningMessage: `Synchronizing "Workstations" with Endpoint Management will delete the existing inventory in your BCMP.`,
          message: `Do you want to continue with syncing your ${count} workstations?`,
          handleYesClick: _performSynchronizeFromNetComply,
          handleNoClick: _closeConfirmImportFromEndpointManagementDialog,
        }),
      );

      ssDialogService.show(ssDialogService.dialogs.bcp.confirmImportWorkstatonsFromEndpointManagementDialog);
    });
  }

  function _performSynchronizeFromDatto($event) {
    loaderService.showViewLoader = true;

    return bcpDataService.synchronizeWorkstationsFromDatto(vm.assessmentId).then(
      result => {
        loaderService.showViewLoader = false;
        if (result.data) {
          alerts.success('The Endpoint Management Workstation synchronization was successful.');
          $rootScope.$broadcast('setDocumentRegenerateFlag');
          $rootScope.$broadcast('refreshBCPWorkstations');
          _closeConfirmImportFromEndpointManagementDialog();
        } else {
          alerts.error('Error occurred synchronizing Endpoint Management Workstation(s).');
        }
      },
      () => {
        loaderService.showViewLoader = false;
        alerts.error('Error occurred synchronizing Endpoint Management Workstation(s).');
      },
    );
  }

  function _performSynchronizeFromNetComply($event) {
    loaderService.showViewLoader = true;

    return bcpDataService.synchronizeWorkstationsFromNetComply(vm.assessmentId).then(
      result => {
        loaderService.showViewLoader = false;
        if (result.data) {
          alerts.success('The Endpoint Management Workstation synchronization was successful.');
          $rootScope.$broadcast('setDocumentRegenerateFlag');
          $rootScope.$broadcast('refreshBCPWorkstations');
          _closeConfirmImportFromEndpointManagementDialog();
        } else {
          alerts.error('Error occurred synchronizing NetComply Workstation(s).');
        }
      },
      () => {
        loaderService.showViewLoader = false;
        alerts.error('Error occurred synchronizing NetComply Workstation(s).');
      },
    );
  }

  function _closeConfirmImportFromEndpointManagementDialog() {
    ssDialogService.hide(ssDialogService.dialogs.bcp.confirmImportWorkstatonsFromEndpointManagementDialog);
  }

  function _handleImportedWorkstations() {
    $rootScope.$broadcast('setDocumentRegenerateFlag');
    $rootScope.$broadcast('refreshBCPWorkstations');
  }

  /** *********************************************
   * Private Functions
   */

  function _activate() {
    _initEventListeners();
    _initPermissions();
  }

  function _initEventListeners() {}

  function _initPermissions() {
    vm.canExpand = vm.workstationStatus !== '0 WorkStations Added';

    return userService.getUserPermissionSet('bcp').then(permissions => {
      vm.permissions = permissions;
    });
  }
}

WorkstationsController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'confirmDialog',
  'alerts',
  'loaderService',
  'userService',
  'bcpDataService',
  'editWorkstationDialog',
  'deleteWorkstationsDialog',
  'ssDialogService',
];
